import styled from "styled-components";

export const DragZone = styled.div<any>`
    width: 80%;
    min-height: 100px;
    margin: 0 auto;

    background-color: rgba(97, 199, 136, 0.518);
    border-radius: 20px;
    border: solid #009639;


    display: flex;
    justify-content: center;
    align-items: center;
    
    position: relative;
`;

export const TextDrag = styled.p`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #045c1e;

    svg {
        font-size: 4rem;
    }


`;